module.exports = __webpack_public_path__ + "static/Anbaugebiet-Ahr-400x320-9b68a665cd2c6ca29e0bdd333946596e.jpeg";